export const termsMap: any = {
    jp: [
        {
            isHeader: true,
            title: '製品に関する注釈\n\n',
        },
        {
            title: '*1 気温25℃、6畳以下の空間を想定した場合の概算データです。使用環境などに応じて変動する可能性がありますのでご注意ください。',
        },
        {
            title: '*2 別売り専用バッテリーパック使用、省エネモード稼働時',
        },
        {
            title: '*3 45L / 55L製品のみ',
        },
        {
            title: '*4 35L製品、外気温25°Cで庫内温度を4°Cに設定した場合の概算値（45L、55Lは39時間）',
        },
        {
            title: '*5 35L製品：最大58本 / 45L製品：最大72本',
        },
        {
            title: '*6 逆充電機能、バッテリーメンテナンス機能を使用するためには、XT150ケーブル（別売り）が必要です。',
        },
        {
            title: '*7 取り付けの際は、専門ディーラー様またはビルダー様にお問い合わせいただき、施工いただくことを推奨します。',
        },

        {
            isHeader: true,
            title: '新製品発売キャンペーンに関する規約\n\n',
        },
        {
            title: '1. キャンペーン期間：2025年4月24日（木）～5月7日（水）',
        },
        {
            title: '2. 会員限定セール：2025年4月28日（月）11:00～2025年5月7日（水）23:59',
        },
        {
            title: '3. 販売台数には一部限りがあるため、なくなり次第終了となります。ご了承ください。',
        },
        {
            title: '4. 本ウェブサイトでご注文される場合、発送地域は日本のみとなります。',
        },
        {
            title: '5. 製品を安全に配送するため、WAVE 3、GLACIER Classic、500W Alternator Charger、ソーラーパネル、アクセサリーおよびプレゼントは別々の梱包で発送いたします。ご了承ください。',
        },
        {
            className: 'text-indent',
            title: (
                <>
                    6. WAVE 3および関連セットの購入プレゼントについて
                    <br />
                    1)
                    購入特典やプレゼントの変更や交換は承っておりません。万が一、注文をキャンセルまたは返品する場合、購入プレゼントおよびお買い上げ特典プレゼントもキャンセルまたは返品いただきます。
                    <br />
                    2) LINEフォロワー様限定特典には限りがございます。なくなり次第終了となりますので、ご了承ください。
                </>
            ),
        },
        {
            title: (
                <>
                    7. プレゼント対象に該当するかのご確認やその他お問い合わせについては、お手数ですがメールにてカスタマサービスセンター（
                    <a href="mailto:hello.jp@ecoflow.com">hello.jp@ecoflow.com</a>）までご連絡ください。
                </>
            ),
        },
        {
            title: (
                <>
                    8.商品が発送されていない場合に限り、ご注文のキャンセルおよび返金を承ります。お客様のご都合により、購入商品到着後30日以内に返品される場合、初回取引手数料と送料をご請求させていただきますので、ご了承ください。返品・返金についての
                    <a href="https://jp.ecoflow.com/pages/online-store-policy">詳細はこちら</a>をご覧ください。{' '}
                </>
            ),
        },
    ],
};
